import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Check } from "lucide-react";

export default function Unsubscribe() {
  const [params] = useSearchParams();
  const [done, setDone] = useState(false);

  useEffect(() => {
    const token = params.get("token") || "";
    const kind = params.get("kind") || "daily";
    const endpoint = (kind === "wisdom" || kind === "send") ? "/wisdom-unsubscribe" : "/daily-unsubscribe";
    // /wisdom-unsubscribe maps to /api/wisdom/unsubscribe below via the api base
    const path = (kind === "wisdom" || kind === "send") ? "/wisdom/unsubscribe" : "/daily-unsubscribe";
    api.post(path, { token }).finally(() => setDone(true));
  }, [params]);

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-5 py-16 bg-[#FDFBF7]">
      <div data-testid="unsubscribe-card" className="max-w-md w-full text-center rounded-3xl border border-[#E2E8F0] bg-white px-8 py-12">
        <div className="mx-auto mb-6 grid place-items-center w-14 h-14 rounded-full bg-[#F1F5F1]">
          <Check className="w-7 h-7 text-[#2C4C3B]" />
        </div>
        <h1 className="font-serif-display text-3xl text-[#0F172A]">You've been unsubscribed.</h1>
        <p className="text-[#475569] mt-3 leading-relaxed">
          {done ? "You will no longer receive these messages." : "Processing your request…"}
        </p>
        <p className="text-sm text-[#94A3B8] mt-6">Your account and any other preferences are unchanged.</p>
        <Link to="/" data-testid="unsubscribe-home-link" className="inline-block mt-8 px-6 py-3 rounded-full bg-[#2C4C3B] text-white font-medium">
          Return to I Need a Proverb
        </Link>
      </div>
    </div>
  );
}
